import React from 'react';
import { colors } from '../../../../../../colorVars';
import { Body3 } from '../../../../../atomic/text/Text';

export const AlertWatchlistComponentHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Symbol
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Direction
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Setup
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Trigger
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Distance
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Last
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            Status
          </Body3>
        </th>
        <th>
          <Body3 color={colors.lightGrey} fontWeight={700}>
            FTFC
          </Body3>
        </th>
        <th title="Repeating">
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Body3 color={colors.lightGrey} fontWeight={700}>
              🔄
            </Body3>
          </div>
        </th>
      </tr>
    </thead>
  );
};

/*
-symbol
-setup
- setupDetails
- filterStatus
- proximity to trigger
- setup filter 1
- setup filter 2
- setup filter 3
- setup filter 4
- repeating
- bid
- ask
- last
- percent change

*/
